import SmartFeedEngine from "SmartFeed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import { CONTENT_CREATOR } from "@/constants/expert-constants";

export const useOrgCommunityContentCreatorExpertiseFeedStore = defineSmartFeedPiniaStore(
  "org-community-content-creator-expertise-feed-store",
  {
    state: () => ({
      smartFeedEngine: new SmartFeedEngine(),
      defaultFilterValues: {
        expertise: {
          key: "expertise",
          payload: CONTENT_CREATOR,
        },
      },
      metadata: {
        lastId: Number.MAX_SAFE_INTEGER,
      },
    }),
    getters: {
      feedUrl() {
        return "/expert/community";
      },
    },
  },
);
